import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/node_modules/lucide-react/dist/esm/Icon.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/wallet-asset-management/components/BalanceBreakdown.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/wallet-asset-management/components/SendForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/wallet-asset-management/components/TransactionHistory.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/wallet-asset-management/components/WalletHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/AppLayout.tsx");
